export const randomBool = (weight = 0.5): boolean => Math.random() <= weight
export const randomInt = (min, max): number =>
  Math.floor(Math.random() * (max - min + 1) + min)
export const getRoll = (possibleOutcomes: number) =>
  Math.floor(Math.random() * possibleOutcomes) + 1 // [1, chance]

/**
 * the entropyValue is used to add randomness to probability scenarios
 * @description 100 times an entropyValue of 10 would yield 1000 possible scenarios.
 */
export const entropyValue: number = 10
